export const borderWidth = {
  thin: '0.0625rem',
  thick: '0.125rem',
  thicker: '0.25rem',
  default: '0.0625rem',
}
